import { useEffect, useState } from "react";
import { Modal, Schema, Input, Loader } from "rsuite";
import { useTranslation } from "react-i18next";

import { OrderServices } from "../../../core/services/OrderServices";
import { get } from "lodash/fp";
import OrderServiceRateItems from "./OrderServiceRateItems";
import RateOrder from "./RateOrder";

const RateOrderModal = ({
  openModal,
  setOpenModal,
  orderId,
  onServeOrder,
  permission,
}: {
  openModal: boolean;
  setOpenModal: any;
  orderId: number;
  onServeOrder: Function;
  permission: any;
}) => {
  const { t } = useTranslation();
  const [loader, setLoader] = useState(false);
  const [orderInfo, setOrderInfo] = useState<any>({});
  const [custInfo, setCustInfo] = useState<any>({});
  async function getViewOrderDetail(id: number) {
    try {
      setLoader(true);
      const res = await OrderServices.viewOrder(id);
      const orderData = get("data.data", res);
      setLoader(false);
      if (orderData) {
        setOrderInfo({ ...orderData });
        setCustInfo({ ...orderData?.customer });
      }
    } catch (error) {
      setLoader(false);
    }
  }
  useEffect(() => {
    getViewOrderDetail(orderId);
  }, []);

  return (
    <div className="modal-container">
      <Modal
        open={openModal}
        backdrop={true}
        onClose={(e: any) => {
          setOpenModal("");
        }}
        size="sm"
      >
        <Modal.Header>
          <h4>
            {t("RATE")} {t("ORDER")} {t("FOR")} <b>{custInfo.name}</b>
            {" ("}
            <b>{custInfo.mobile}</b>
            {" )"}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="rate-order">
            {loader && (
              <Loader
                style={{ zIndex: 9999 }}
                size="lg"
                backdrop
                content={t("LOADING")}
                vertical
              />
            )}
            {orderInfo?.id > 0 && (
              <RateOrder
                openModal={openModal}
                setOpenModal={setOpenModal}
                orderObj={orderInfo}
                onServeOrder={onServeOrder}
                permission={permission}
              />
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default RateOrderModal;
